import { defineMessages } from 'react-intl';

const scope = 'cb.screens';

export default defineMessages({
  search: {
    id: `${scope}.search`,
    defaultMessage: 'Start typing your city',
  },
  searchResultText: {
    id: `${scope}.searchResultText`,
    defaultMessage: 'Search Results',
  },
  recentSelectText: {
    id: `${scope}.recentSelectText`,
    defaultMessage: 'Recently Selected',
  },
});
